import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReferralAppProvider from './Referral/ReferralAppProvider';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme();
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <ReferralAppProvider>
          <App />
        </ReferralAppProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// Measure performance: pass a function to log results or send to an analytics endpoint
reportWebVitals(console.log);
